<template>
  <div class="header">
    <div class="menu">
      <div class="logo">
        <router-link tag="a" to="/"><i class="icon-nkn-logo"></i></router-link>
      </div>
      <div class="nav">
        <nkn-header-nav></nkn-header-nav>
        <nkn-header-lang></nkn-header-lang>
        <nkn-header-nav-media></nkn-header-nav-media>
      </div>
    </div>
  </div>
</template>

<script>
  import nknHeaderNav from '@/components/header/nknHeaderNav'
  import nknHeaderLang from '@/components/header/nknHeaderLang'
  import nknHeaderNavMedia from '@/components/header/nknHeaderNavMedia'

  export default {
    components: {
      nknHeaderNav,
      nknHeaderLang,
      nknHeaderNavMedia
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/header/nknHeader.vue